import { render } from "./MainPage.vue?vue&type=template&id=d7b818c2&scoped=true"
import script from "./MainPage.vue?vue&type=script&lang=js"
export * from "./MainPage.vue?vue&type=script&lang=js"

import "./MainPage.vue?vue&type=style&index=0&id=d7b818c2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d7b818c2"

export default script